import { useState, useEffect } from 'react';

/**
 * Hook para renderizar componentes apenas durante um período específico de tempo.
 * @param {Object} config - Configuração do período
 * @param {Date} config.startDate - Data de início para renderização
 * @param {Date} config.endDate - Data de término para renderização
 * @returns {boolean} - Verdadeiro se estiver dentro do período de renderização
 */
const useTimeBasedRender = ({ startDate, endDate }) => {
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    let interval;

    // Função para verificar se a data atual está dentro do período especificado
    const checkDateRange = () => {
      const currentDate = new Date();
      const isWithinRange = currentDate >= startDate && currentDate <= endDate;
      setShouldRender(isWithinRange);
    };

    // Função para iniciar o intervalo apenas quando a aba estiver visível
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        checkDateRange(); // Verifica imediatamente ao entrar na aba
        interval = setInterval(checkDateRange, 60000); // Verifica a cada 60s
      } else {
        clearInterval(interval); // Para quando sair da aba
      }
    };

    // Adiciona o listener para detectar mudança de visibilidade
    document.addEventListener("visibilitychange", handleVisibilityChange);

    // Executa imediatamente ao montar
    handleVisibilityChange();

    return () => {
      clearInterval(interval);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [startDate, endDate]);

  return shouldRender;
};

export default useTimeBasedRender;
